import {
  POINT_TYPES,
  MAP_NAMES
} from 'entities/map';

export const mappingCoordinate = (coordinates: string) => ({
  key: coordinates,
  value: coordinates,
  metadata: coordinates,
  coordinates: {
    lat: parseCoordinatesFromString(coordinates)[0],
    lng: parseCoordinatesFromString(coordinates)[1]
  },
  type: POINT_TYPES.coordinates
});

const getSeparator = (value: string) => {
  const modifiedValue = value.toString().trim();

  if (modifiedValue.includes(',')) return ', ';
  if (modifiedValue.includes('\t')) return '\t';
  return ' ';
};

export const parseCoordinatesFromString = (value: string) => {
  const separator = getSeparator(value);
  const separatedValue = value.split(separator);

  const latitude = separatedValue.shift() || '';
  const longitude = separatedValue.pop() || '';

  return [+latitude, +longitude];
};

export const checkIsGoogleMap = () => (
  window.map?.name === MAP_NAMES.google
);

const MIN_LAT_LNG_SPACING = 10;

export const getValidGoogleFitBounds = (
  fitBounds: google.maps.LatLngBounds,
  spacing: number = MIN_LAT_LNG_SPACING
) => {
  const result = {
    sw: fitBounds.getSouthWest().toJSON(),
    ne: fitBounds.getNorthEast().toJSON()
  };

  const latSpacing = Math.abs(result.ne.lat - result.sw.lat);
  const lngSpacing = Math.abs(result.ne.lng - result.sw.lng);

  if (latSpacing < spacing) {
    result.sw.lat -= (spacing - latSpacing) / 2;
    result.ne.lat += (spacing - latSpacing) / 2;
  }

  if (lngSpacing < spacing) {
    result.sw.lng -= (spacing - latSpacing) / 2;
    result.ne.lng += (spacing - latSpacing) / 2;
  }

  return result;
};